import { useState } from 'react'
import { styled } from '@mui/material'
import { useIntl } from 'react-intl'
import { colorPalette } from '../../../../style/colorPalette'
import { Button } from '../../../../components/buttons'
import AlertDialog from '../../../../components/dialogs/AlertDialog'
import { isEmailChangeable } from '../../../../../domain/entity/UserEntity'
import { AttemptChangeUserEmailButton } from '../../../User/AttemptChangeUserEmailButton'

type MeSubHeaderProps = {
  canSubmit: boolean
  onSubmit: () => void
  onReload: () => void
  // 編集中（未保存の変更あり）か。リロード時の破棄確認に使う。
  isEdited: boolean
  // 取得・保存の往復中か。リロードを併走させると取得結果が完了順で上書きされる。
  isBusy: boolean
  // 取得前・取得失敗時はメールアドレス変更の対象が定まらないため undefined になる。
  userUuid: string | undefined
  registrationStatus: string | undefined
}

// ユーザー情報画面のサブヘッダー。更新のみの画面のため、作成・削除の導線は持たず、
// 更新とリロード、メールアドレス変更だけを置く。
export const MeSubHeader = ({
  canSubmit,
  onSubmit,
  onReload,
  isEdited,
  isBusy,
  userUuid,
  registrationStatus,
}: MeSubHeaderProps) => {
  const intl = useIntl()
  const [isReloadConfirmOpen, setIsReloadConfirmOpen] = useState(false)
  const handleReload = () => {
    if (isEdited) {
      setIsReloadConfirmOpen(true)
      return
    }
    onReload()
  }
  return (
    <SubHeaderRoot>
      <StyledButton
        variant="filled"
        colorPattern="skyBlue"
        size="s"
        disabled={!canSubmit}
        onClick={onSubmit}
      >
        {intl.formatMessage({ id: 'me.edit.update.submitButton' })}
      </StyledButton>
      <StyledButton
        variant="outlined"
        colorPattern="monotone"
        size="s"
        disabled={isBusy}
        onClick={handleReload}
      >
        {intl.formatMessage({ id: 'reload' })}
      </StyledButton>
      {/* メールアドレスは本人確認メールを経由して変更するため、単票では編集させず
          ここから変更する。 */}
      {userUuid && isEmailChangeable(registrationStatus) && (
        <RightGroup>
          <AttemptChangeUserEmailButton uuid={userUuid} />
        </RightGroup>
      )}
      <AlertDialog
        isOpen={isReloadConfirmOpen}
        message={intl.formatMessage({ id: 'meV2.reload.confirm' })}
        submitButtonTitle={intl.formatMessage({ id: 'reload' })}
        submitHandler={() => {
          setIsReloadConfirmOpen(false)
          onReload()
        }}
        closeButtonTitle={intl.formatMessage({ id: 'dialog.cancel' })}
        closeHandler={() => setIsReloadConfirmOpen(false)}
        loading={isBusy}
      />
    </SubHeaderRoot>
  )
}

const SubHeaderRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '6px 12px',
  backgroundColor: colorPalette.monotone[0],
  borderBottom: `1px solid ${colorPalette.monotone[2]}`,
  gap: '8px',
})
const RightGroup = styled('div')({
  marginLeft: 'auto',
})
const StyledButton = styled(Button)({
  minWidth: '100px',
})
